// import Vue from 'vue'
import { ValidationProvider, extend, localize } from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN.json'

// Register it globally（推荐局部注册）
//   Vue.component('ValidationProvider', ValidationProvider);
localize('zh_CN', zh_CN)
// 必须.
extend('required', {
    validate:value=>{
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        }
    },
    message:'请输入{_field_}{_value_}',
        // message: (fieldName, placeholders) => {
    //     return `The ${fieldName} field must have at least ${placeholders.min} characters and ${placeholders.max} characters at most`;
    //   }
    // computesRequired: true
})
//正整数
extend('positiveInteger', {
    validate: value => {
        // if (!value || !Number(value)) {
        //     return false
        // }
        let reg = /^[1-9]\d*$/;//判断正整数的正则
        return reg.test(value)
    },
    // message: (fieldName, placeholders) => {
    //     return `The ${fieldName} field must have at least ${placeholders.min} characters and ${placeholders.max} characters at most`;
    //   }
    message: '请输入{_field_}！{_value_}'
});
//姓名
extend('name', {
    validate: value => {
        let reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;//验证姓名
        return reg.test(value)
    },
    message: '请输入姓名'
})
//手机号
extend('mobile', {
    validate: value => {
        const reg = /^1[3456789]\d{9}$/;
        return reg.test(value)
    },
    message: '手机号格式错误'
})
//身份证号
extend('idCard', {
    validate: value => {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        // return reg.test(value)
        return reg.test(value)
    },
    message: '身份证格式错误'
})
// extend('required', {
//     validate:value=>{
//         console.log("value:"+value)
//         return value.toString().trim().length>0
//     },
//     message:'请输入{_field_}{_value_}',
//         // message: (fieldName, placeholders) => {
//     //     return `The ${fieldName} field must have at least ${placeholders.min} characters and ${placeholders.max} characters at most`;
//     //   }
//     // computesRequired: true
// })
//
extend('check', {
    validate: value => {
        console.log("value:"+value)
        return ['', null, undefined].indexOf(value) === -1
    },
    message: '手机号格式错误'
})
export default ValidationProvider


// //自定义validate
// const dictionary = {
//     zh_CN:{
//         messages:{
//             required:filed=>'请' + filed,
//             number:filed => filed + '必须为数值',
//             url:()=>'请输入正确格式的服务器地址',
//             ip:()=>'请输入正确的IP地址'
//         },
//         attributes:{
//             ip:'输入IP地址',
//             httpPort:'输入HTTP端口',
//             userName:'输入用户昵称',
//             mobile:'输入手机号码',
//             emailAdd:'输入邮件地址',
//             authCode:'输入您收到的验证码',
//             loginPwd:'输入登录密码',
//             confirmPwd:'两次密码不一致',//确认密码
//             transactionPwd:'输入交易密码',
//             recommender:'输入您的推荐人',
//             isSee:'阅读用户协议，并同意',
//         }
//     }
// }
// Validator.updateDictionary(dictionary)

// //1.IPV4地址
// Validator.extend('ipAddr',{
//     messages:{zh_CN:()=>'请输入正确的IPV4地址'},
//     validate:value=>{
//         return /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/.test(value)
//     }
// })

// // 2.端口【0~65535】
// Validator.extend('port', {
//     messages: {
//         zh_CN: () => '请输入正确格式的端口号'
//     },
//     validate: value => {
//         return /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(value)
//     }
// })

// // 3.用户昵称
// Validator.extend('userName', {
//     messages: {
//         zh_CN: () => '用户昵称不允许特殊符号'
//     },
//     validate: value => {
//         return /^[\u4e00-\u9fa5A-Za-z0-9]*$/.test(value)
//     }
// })

// // 4.手机号
// Validator.extend('phone', {
//     messages: {
//         zh_CN: () => '手机号格式不正确'
//     },
//     validate: value => {
//         return /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/.test(value)
//     }
// })

// // 5.邮箱
// Validator.extend('email', {
//     messages: {
//         zh_CN: () => '邮箱格式不正确'
//     },
//     validate: value => {
//         return /^([\w-.]+)@([\w-.]+)(\.[a-zA-Z0-9]+)$/.test(value)
//     }
// })

// // 6.验证码
// Validator.extend('code', {
//     messages: {
//         zh_CN: () => '验证码格式不正确'
//     },
//     validate: value => {
//         return /^[0-9]*$/.test(value)
//     }
// })

// // 6.登录密码
// Validator.extend('logPwd', {
//     messages: {
//         zh_CN: () => '登录密码格式不正确(6-18位)'
//     },
//     validate: value => {
//         return /^\S{6,18}$/.test(value)
//     }
// })
// // 7.交易密码
// Validator.extend('transactionPwd', {
//     messages: {
//         zh_CN: () => '交易密码格式不正确'
//     },
//     validate: value => {
//         return /^\S{6,18}$/.test(value)
//     }
// })
// // 8.推荐人
// Validator.extend('recommender', {
//     messages: {
//         zh_CN: () => '推荐人格式不正确'
//     },
//     validate: value => {
//         return /^[^\u4e00-\u9fa5]{0,}$/.test(value)
//     }
// })

// // 9.用户协议
// Validator.extend('userProtocol', {
//     messages: {
//         zh_CN: () => '请阅读用户协议，并同意'
//     },
//     validate: () => {
//         return true
//     }
// })


// // 10.忘记密码，确认新的登录密码
// Validator.extend('qrwd', {
//     messages: {
//         zh_CN: () => '登录密码格式不正确[6~18位]'
//     },
//     validate: value => {
//         return /^\S{6,18}$/.test(value)
//     }
// })